import { useEffect, useState } from "react";
import { MapPin } from "@phosphor-icons/react";
import { api } from "@/lib/api";

let _list = null;
let _promise = null;
const loadProjects = () => {
  if (_list) return Promise.resolve(_list);
  if (!_promise) _promise = api.get("/ops-projects").then((r) => { _list = r.data || []; return _list; }).catch(() => []);
  return _promise;
};

export const useProjectName = () => {
  const [list, setList] = useState(_list || []);
  useEffect(() => { loadProjects().then(setList); }, []);
  return (id) => { const p = list.find((x) => x.id === id); return p ? (p.code || p.name) : null; };
};

// Etiqueta del depósito/proyecto de un registro. Oculta si el registro no tiene proyecto.
export default function ProjectBadge({ id, className = "", testid }) {
  const name = useProjectName()(id);
  if (!id) return null;
  return (
    <span className={`inline-flex items-center gap-0.5 text-[10px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded bg-blue-900 text-white ${className}`}
          data-testid={testid || `project-badge-${id}`} title="Depósito / Proyecto">
      <MapPin size={9} weight="fill" /> {name || "Proyecto"}
    </span>
  );
}
